// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"b2e415f9","242":"7c1aa934","751":"198be6b6"}[chunkId] + ".chunk.css";
};